import {
  IToolHistoryGroupReference,
  TToolHistoryResponse,
  TToolHistoryItem,
  IToolHistoryEntry,
  IToolHistoryGrouped,
  IToolHistoryUngrouped,
  TOOL_HISTORY_ITEM_TYPE
} from 'types/toolHistory.types';
import { ToolHistoryGroupReferenceType } from 'constants/tool-history.constants';
import { getProcessedEventContent, resolverDate } from 'utils/toolHistory';
import { BordOneToneIcon } from 'components/NudosComponents';
import { IHistoryStepLink } from './components/ToolHistoryStepper/HistoryStepHeader/HistoryStepHeader';
import { IHistoryStep } from './components/ToolHistoryStepper/ToolHistoryStepper';
import { LocationMarkers } from './components/ToolHistoryStepper/LocationMarkers/LocationMarkers';
import { nudosTextcolor } from 'styles/styles.constants';


/**
 * Genera el link de una orden o servicio logístico
 * @param reference - Referencia del grupo
 * @returns Objeto con label y url, o null
 */
export const generateReferenceLink = (reference?: IToolHistoryGroupReference): IHistoryStepLink | null => {
  if (!reference?.referenceId) return null;

  const { referenceType, referenceId } = reference;

  if (referenceType === ToolHistoryGroupReferenceType.ORDER) {
    return {
      label: `Orden N° ${referenceId}`,
      url: `/order/details/${referenceId}`
    };
  }

  if (referenceType === ToolHistoryGroupReferenceType.SERVICE) {
    return {
      label: `SL N° ${referenceId}`,
      url: `/logistic-service/details/${referenceId}`
    };
  }

  return null;
};

/**
 * Transforma el historial de herramientas en pasos para el stepper
 * @param toolHistory - Respuesta del historial
 * @returns Array de pasos formateados
 */
export const formatToolHistory = (toolHistory?: TToolHistoryResponse): IHistoryStep[] => {
  if (!toolHistory) return [];

  return toolHistory.map((item: TToolHistoryItem): IHistoryStep => {
    if (item.type === TOOL_HISTORY_ITEM_TYPE.EVENT) {
      const { uuid, type, relevantInfo } = item as IToolHistoryUngrouped;
      const { title } = getProcessedEventContent(uuid, relevantInfo);

      return {
        header: {
          type,
          icon: (
            <div className="circledIcon">
              <BordOneToneIcon variant="package" standardSize={10} stroke={nudosTextcolor} />
            </div>
          ),
          title: title || '',
          date: resolverDate(relevantInfo?.createdAt)
        }
      };
    }

    const { type, location, reference, events } = item as IToolHistoryGrouped;
    const isCancelled = !!reference?.isCancelled;

    return {
      header: {
        type,
        icon: <LocationMarkers origin={location?.origin} destination={location?.destination} />,
        link: generateReferenceLink(reference),
        isCancelled
      },
      events: events?.map((event: IToolHistoryEntry) => {
        const { uuid, relevantInfo } = event;
        const { title, description } = getProcessedEventContent(uuid, relevantInfo);

        return {
          title: title || '',
          date: resolverDate(relevantInfo?.createdAt),
          description: description || ''
        };
      })
    };
  });
};
